<template>
  <div :class='{"sidebar": true, "collapsed": collapsed}'>
    <!-- <sidebar-menu :menu="menu" width="250px" :disableHover="true" hideToggle id="sidebar-menu">
      <div slot="header"><h2 class="text-white p-3">Puppet</h2></div>
    </sidebar-menu> -->

    <sidebar-menu :menu="menu" width="250px" :disableHover="true" id="sidebar-menu" :collapsed="collapse" @toggle-collapse="onToggleCollapse" @item-click="item_click">
      <!-- <i class="fa fa-arrows-h" ></i> -->
      <span slot="toggle-icon"><span v-if="collapsed" key="right"><i key="right-icon" class="fas fa-chevron-right"></i></span><span v-else key="left"><i key="left-icon" class="fas fa-chevron-left"></i></span></span>
      <div slot="header">
        <b-link to="/dashboard" class="no-decoration">
          <div class="text-center" v-if="collapsed"><img src="@/assets/logo.png" height="38px" class="mt-2 p-1" /></div>
          <div v-else class="p-3">
            <img src="@/assets/logo.png" height="64px"/>
            <h1 class="text-white no-decoration d-inline-block ml-2 title" style="position: relative; top: 12px; font-weight: 400;">Vidon</h1>
          </div>
        </b-link>
      </div>

      <div slot="footer" v-if="!collapsed" class="p-2 text-white" id="tooltip-target-1">
        <b-row>
          <b-col>
            <span>Videos</span>
          </b-col>
          <b-col class='text-right'>
            <span>{{recipients_left.used}} / {{recipients_left.total}}</span>
          </b-col>
        </b-row>
        <b-progress :value="recipients_left.percent" variant="dark" height="3px" class="mt-2 w-100"></b-progress>

        <b-tooltip target="tooltip-target-1" triggers="hover">
          Resets on {{profile.team.current_period_end | date}}
        </b-tooltip>
      </div>

      <div slot="footer" v-if="!collapsed && profile.onboarding_step !== 'wait'">
        <div class="notice text-center">
          <span>Finish your onboarding</span>
          <b-button class="mt-2" block :to="{name: 'onboarding_welcome'}">Finish onboarding</b-button>
        </div>
      </div>

      <div slot="footer" v-if="!collapsed">
        <div class="notice text-center" v-if="trial_days_left !== undefined">
          <span v-if="trial_days_left > 0">{{trial_days_left}} day{{trial_days_left != 1 ? 's' : ''}} left of your trial</span>
          <span v-else>Your trial is over.</span>
          <b-button class="mt-2" block :to="{name: 'billing'}">Upgrade</b-button>
        </div>
      </div>
    </sidebar-menu>

    <router-view :profile="profile" :user="user" class="app-navigation"/>
  </div>
</template>

<script>
import { remote_config } from '@/main.js'
import constants from '@/lib/constants'
import moment from 'moment/src/moment'

export default {
  props: ['profile', 'user'],
  data () {
    let menu = [
      // {href: {name: 'dashboard'}, title: 'Dashboard', icon: 'fad fa-tachometer'},

      {href: {name: 'projects'}, title: 'Video Templates', icon: 'fad fa-video', alias: '/projects/:id/:sub_dir?'},
      {href: {name: 'voice', params: {id: this.profile.avatar.id}}, title: 'My Clone', icon: 'fad fa-user'},
      // {header: true, title: 'Integrations'},
      // {href: `#`, external: true, title: 'Zapier', icon: 'fal fa-bolt'},
      // {href: {name: 'integrations'}, title: 'Integrations', icon: 'fad fa-plug'},
      {header: true, title: 'Account'},
      {href: {name: 'settings'}, title: 'Settings', icon: 'fad fa-cog'},
    ]

    if (remote_config.getValue('show_sequences').asBoolean() || this.profile.features && this.profile.features.sequences) {
      menu.splice(0, 0, {href: {name: 'sequences'}, title: 'Sequences', icon: 'fad fa-envelope-open-text', alias: '/sequences/:id/:sub_dir?'},)
    }

    if (this.profile.team_role.role === constants.team_role.admin) {
      menu.push({href: {name: 'team'}, title: 'Team', icon: 'fad fa-user-plus'})
      menu.push({href: {name: 'billing'}, title: 'Billing', icon: 'fad fa-wallet'})
    }

    // window.HubSpotConversations.widget.open();

    menu.push({header: true, title: 'Support'})
    menu.push({href: '#', external: true, title: 'Help Center', icon: 'fad fa-question-circle'})
    menu.push({href: '#', external: true, title: 'Contact', icon: 'fad fa-user-headset'})

    if (this.profile.role === constants.roles.admin) {
      menu.splice(2, 0, {href: {name: 'voices'}, title: 'Clones', icon: 'fad fa-users', alias: '/voices/:id/:sub_dir?'})
      menu.splice(1, 0, {href: {name: 'image_templates'}, title: 'Image Templates', icon: 'fad fa-images', alias: '/image_templates/:id/:sub_dir?'})
      menu.push({header: true, title: 'Admin'})
      menu.push({href: {name: 'admin'}, title: 'Admin', icon: 'fad fa-toolbox', alias: '/admin:sub_dir?'})
    }

    let collapse = false
    if (window.innerWidth < 600) {
      collapse = true
    }

    return {
      collapsed: collapse,
      collapse: collapse,
      menu
    }
  },
  mounted() {
    if (this.profile.onboarding_step !== 'complete' && (!this.profile.team || this.profile.team.plan === null || this.profile.onboarding_step !== 'wait')) {
      this.$router.push({name: 'onboarding_welcome'})
    }
  },
  computed: {
    trial_days_left() {
      if (this.profile.team && this.profile.team.trial && this.profile.team.current_period_end) {
        return moment(this.profile.team.current_period_end.toDate()).diff(moment(), 'days')
      }

      return undefined
    },
    recipients_left() {
      if (this.profile.team.current_period && this.profile.team.current_period.id && this.profile.team.current_period.usage[this.profile.id] && this.profile.team.current_period.usage[this.profile.id].recipients) {
        return {
          used: this.profile.team.current_period.usage[this.profile.id].recipients,
          total: this.profile.team.max_usage_in_period_per_user,
          percent: (this.profile.team.current_period.usage[this.profile.id].recipients / this.profile.team.max_usage_in_period_per_user) * 100
        }
      } else {
        return {
          used: 0,
          total: this.profile.team.max_usage_in_period_per_user || 0,
          percent: 0
        }
      }
    }
  },
  methods: {
    item_click(e, item) {
      if (item.title === 'Zapier') {
        window.open(`https://zapier.com/developer/public-invite/119198/ad857700147124f28294fa659caebedb/`, '_blank')
      }
      if (item.title === 'Support' || item.title == 'Help Center') {
        window.open(`https://support.vidon.ai`, '_blank')
      }
      if (item.title === 'Contact') {
        window.HubSpotConversations.widget.open()
      }
      // if (item.title === 'Extension') {
      //   window.open(`https://chrome.google.com/webstore/detail/rep-replacer-extension/beeojbagmhomlmgjcopnnjpbomffkfhb`, '_blank')
      // }
    },
    onToggleCollapse(collapsed) {
      this.collapsed = collapsed
    }
  }
}
</script>

<style>

.notice {
  width: 100%;
  padding: 2em;
  color: white;
  background: #051e34;
}

</style>
